import { Mesh } from 'three';
import React from 'react';

export default {
    name: 'chimney-sign',
    prototype: 'items',

    info: {
        tag: ['chimney-sign'],
        title: 'Chimney Sign',
        description: 'Chimney Sign',
        image: require('./chimney-sign.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 50
            }
        },
    },

    render2D: function (element, layer, scene) {

        let width = element.properties.get('width').get('length');

        return (
            <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(-5, 0)`}>
                {/* <path id="1" d="M0 0 L16 0 L16 -8 L0 0" style={{ stroke: '#000000', }} /> */}
                {/* <path id="2" d="M0 0 L0 -8 L16 -8 Z" style={{ fill: '#ffffff', stroke: '#000000', strokeWidth: 0.5 }} /> */}
                <rect width="16" height="8" style={{ fill: '#000000' }} />
                <path id="1" d="M1 1 L1 7 L15 1 Z" style={{ fill: '#ffffff' }} />
            </g>
        )
    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
